export const countries: Country[] = [
	{
		uuid: "9d057d2d-1c3e-4b05-b7eb-3399b195cf82",
		name: "Afghanistan",
		countryCode: "af",
		dialCode: "+93",
		currency: "afn",
	},
	{
		uuid: "9d057d2d-1c48-4ebb-a273-e05d35ed935b",
		name: "Aland Islands",
		countryCode: "ax",
		dialCode: "+340",
		currency: "eur",
	},
	{
		uuid: "9d057d2d-1c4b-48ae-9d22-34306fce6f62",
		name: "Albania",
		countryCode: "al",
		dialCode: "+355",
		currency: "all",
	},
	{
		uuid: "9d057d2d-1c4d-4e8d-a135-767fc4894fd3",
		name: "Algeria",
		countryCode: "dz",
		dialCode: "+213",
		currency: "dzd",
	},
	{
		uuid: "9d057d2d-1c50-45f3-9fa6-60cde9c9761a",
		name: "American Samoa",
		countryCode: "as",
		dialCode: "-683",
		currency: "usd",
	},
	{
		uuid: "9d057d2d-1c52-494c-b07a-9673d487e065",
		name: "Andorra",
		countryCode: "ad",
		dialCode: "+376",
		currency: "eur",
	},
	{
		uuid: "9d057d2d-1c55-4a68-8143-d96a41adbc0d",
		name: "Angola",
		countryCode: "ao",
		dialCode: "+244",
		currency: "aoa",
	},
	{
		uuid: "9d057d2d-1c57-4b3e-9884-e12ad12bef6a",
		name: "Anguilla",
		countryCode: "ai",
		dialCode: "-263",
		currency: "xcd",
	},
	{
		uuid: "9d057d2d-1c5a-4cad-8379-aa7399d8dcc3",
		name: "Antarctica",
		countryCode: "aq",
		dialCode: "+672",
		currency: "aad",
	},
	{
		uuid: "9d057d2d-1c5c-4595-b2da-eef25ce8f03f",
		name: "Antigua & Barbuda",
		countryCode: "ag",
		dialCode: "-267",
		currency: "xcd",
	},
	{
		uuid: "9d057d2d-1c5d-4d93-85bb-44584535fe83",
		name: "Argentina",
		countryCode: "ar",
		dialCode: "+54",
		currency: "ars",
	},
	{
		uuid: "9d057d2d-1c5f-4b24-8f52-7478fd72c694",
		name: "Armenia",
		countryCode: "am",
		dialCode: "+374",
		currency: "amd",
	},
	{
		uuid: "9d057d2d-1c60-4e0f-b236-b87eff2aa72a",
		name: "Aruba",
		countryCode: "aw",
		dialCode: "+297",
		currency: "awg",
	},
	{
		uuid: "9d057d2d-1c62-4d27-9a71-095af31b7160",
		name: "Australia",
		countryCode: "au",
		dialCode: "+61",
		currency: "aud",
	},
	{
		uuid: "9d057d2d-1c64-4212-9569-d4b4a28522b6",
		name: "Austria",
		countryCode: "at",
		dialCode: "+43",
		currency: "eur",
	},
	{
		uuid: "9d057d2d-1c65-4233-87f5-79e051dd1f19",
		name: "Azerbaijan",
		countryCode: "az",
		dialCode: "+994",
		currency: "azn",
	},
	{
		uuid: "9d057d2d-1c67-4a79-980c-4f98a446d16d",
		name: "Bahrain",
		countryCode: "bh",
		dialCode: "+973",
		currency: "bhd",
	},
	{
		uuid: "9d057d2d-1c68-42b7-88fd-e1f2be72abd5",
		name: "Bangladesh",
		countryCode: "bd",
		dialCode: "+880",
		currency: "bdt",
	},
	{
		uuid: "9d057d2d-1c6a-492e-9fc9-0f9a0937e4b5",
		name: "Barbados",
		countryCode: "bb",
		dialCode: "-245",
		currency: "bbd",
	},
	{
		uuid: "9d057d2d-1c6b-4ee5-b178-031403ed63db",
		name: "Belarus",
		countryCode: "by",
		dialCode: "+375",
		currency: "byn",
	},
	{
		uuid: "9d057d2d-1c6d-429d-aa0d-ea38c1e9071a",
		name: "Belgium",
		countryCode: "be",
		dialCode: "+32",
		currency: "eur",
	},
	{
		uuid: "9d057d2d-1c6e-41a1-80e2-2e0604985d33",
		name: "Belize",
		countryCode: "bz",
		dialCode: "+501",
		currency: "bzd",
	},
	{
		uuid: "9d057d2d-1c70-4d9f-bc1c-645d3dc1d7d2",
		name: "Benin",
		countryCode: "bj",
		dialCode: "+229",
		currency: "xof",
	},
	{
		uuid: "9d057d2d-1c71-4baf-918f-abb4f0d194ad",
		name: "Bermuda",
		countryCode: "bm",
		dialCode: "-440",
		currency: "bmd",
	},
	{
		uuid: "9d057d2d-1c73-4131-8159-7022473fc8de",
		name: "Bhutan",
		countryCode: "bt",
		dialCode: "+975",
		currency: "btn",
	},
	{
		uuid: "9d057d2d-1c74-43ee-9704-5cd134d34988",
		name: "Bolivia",
		countryCode: "bo",
		dialCode: "+591",
		currency: "bob",
	},
	{
		uuid: "9d057d2d-1c76-4d8e-bcac-120842eb4e5c",
		name: "Bosnia & Herzegovina",
		countryCode: "ba",
		dialCode: "+387",
		currency: "bam",
	},
	{
		uuid: "9d057d2d-1c77-46b8-be7d-2f64cee1b785",
		name: "Botswana",
		countryCode: "bw",
		dialCode: "+267",
		currency: "bwp",
	},
	{
		uuid: "9d057d2d-1c79-448a-9c3f-5ba62f1c588f",
		name: "Bouvet Island",
		countryCode: "bv",
		dialCode: "+55",
		currency: "nok",
	},
	{
		uuid: "9d057d2d-1c7a-4784-b951-40483faefb54",
		name: "Brazil",
		countryCode: "br",
		dialCode: "+55",
		currency: "brl",
	},
	{
		uuid: "9d057d2d-1c7c-43a9-b442-e88e9eff075b",
		name: "British Indian Ocean Territory",
		countryCode: "io",
		dialCode: "+246",
		currency: "usd",
	},
	{
		uuid: "9d057d2d-1c7d-49e9-8269-1f5641011aa8",
		name: "British Virgin Islands",
		countryCode: "vg",
		dialCode: "-283",
		currency: "usd",
	},
	{
		uuid: "9d057d2d-1c7f-46c6-acac-f8942d009ed9",
		name: "Brunei",
		countryCode: "bn",
		dialCode: "+673",
		currency: "bnd",
	},
	{
		uuid: "9d057d2d-1c80-46b2-891d-6ecd7677383e",
		name: "Bulgaria",
		countryCode: "bg",
		dialCode: "+359",
		currency: "bgn",
	},
	{
		uuid: "9d057d2d-1c82-4043-9279-080284b53617",
		name: "Burkina Faso",
		countryCode: "bf",
		dialCode: "+226",
		currency: "xof",
	},
	{
		uuid: "9d057d2d-1c83-42d8-aca3-07ba9e9d8610",
		name: "Burundi",
		countryCode: "bi",
		dialCode: "+257",
		currency: "bif",
	},
	{
		uuid: "9d057d2d-1c85-48ac-82d2-86841c196550",
		name: "Cambodia",
		countryCode: "kh",
		dialCode: "+855",
		currency: "khr",
	},
	{
		uuid: "9d057d2d-1c87-4211-a8a8-90243c29f77f",
		name: "Cameroon",
		countryCode: "cm",
		dialCode: "+237",
		currency: "xaf",
	},
	{
		uuid: "9d057d2d-1c88-496d-ba16-b18362284ce6",
		name: "Canada",
		countryCode: "ca",
		dialCode: "+1",
		currency: "cad",
	},
	{
		uuid: "9d057d2d-1c89-498c-9254-0c9906b410a9",
		name: "Cape Verde",
		countryCode: "cv",
		dialCode: "+238",
		currency: "cve",
	},
	{
		uuid: "9d057d2d-1c8b-4875-ab1b-5124401a315a",
		name: "Caribbean Netherlands",
		countryCode: "bq",
		dialCode: "+599",
		currency: "usd",
	},
	{
		uuid: "9d057d2d-1c8c-480c-b5eb-3a9a00daf7c3",
		name: "Cayman Islands",
		countryCode: "ky",
		dialCode: "-344",
		currency: "kyd",
	},
	{
		uuid: "9d057d2d-1c8e-4c22-a2e2-52b55f72d026",
		name: "Central African Republic",
		countryCode: "cf",
		dialCode: "+236",
		currency: "xaf",
	},
	{
		uuid: "9d057d2d-1c8f-492a-83f0-95c69a1e3b7f",
		name: "Chad",
		countryCode: "td",
		dialCode: "+235",
		currency: "xaf",
	},
	{
		uuid: "9d057d2d-1c91-4949-acdc-20f88d947653",
		name: "Chile",
		countryCode: "cl",
		dialCode: "+56",
		currency: "clp",
	},
	{
		uuid: "9d057d2d-1c92-44bc-bf9b-bfd5ebf98bdc",
		name: "China",
		countryCode: "cn",
		dialCode: "+86",
		currency: "cny",
	},
	{
		uuid: "9d057d2d-1c94-4c9c-901c-44321ec6512f",
		name: "Christmas Island",
		countryCode: "cx",
		dialCode: "+61",
		currency: "aud",
	},
	{
		uuid: "9d057d2d-1c95-4520-99d8-a45a146e5791",
		name: "Cocos Islands",
		countryCode: "cc",
		dialCode: "+61",
		currency: "aud",
	},
	{
		uuid: "9d057d2d-1c97-474e-921b-aa9909b0fd6d",
		name: "Colombia",
		countryCode: "co",
		dialCode: "+57",
		currency: "cop",
	},
	{
		uuid: "9d057d2d-1c98-4304-be50-63e36bbbe9d6",
		name: "Comoros",
		countryCode: "km",
		dialCode: "+269",
		currency: "kmf",
	},
	{
		uuid: "9d057d2d-1c9a-4f83-a8df-62b82413d4c2",
		name: "Congo",
		countryCode: "cg",
		dialCode: "+242",
		currency: "xaf",
	},
	{
		uuid: "9d057d2d-1c9b-4602-9aca-13d9ee5c1b34",
		name: "Cook Islands",
		countryCode: "ck",
		dialCode: "+682",
		currency: "nzd",
	},
	{
		uuid: "9d057d2d-1c9d-4816-ab80-a592a4401476",
		name: "Costa Rica",
		countryCode: "cr",
		dialCode: "+506",
		currency: "crc",
	},
	{
		uuid: "9d057d2d-1c9e-4a5f-a388-3493b3ace0b8",
		name: "Cote D'Ivoire",
		countryCode: "ci",
		dialCode: "+225",
		currency: "xof",
	},
	{
		uuid: "9d057d2d-1ca0-4f0e-8045-31e13775cdeb",
		name: "Croatia",
		countryCode: "hr",
		dialCode: "+385",
		currency: "hrk",
	},
	{
		uuid: "9d057d2d-1ca1-43c9-a789-17f55a4dafa2",
		name: "Cuba",
		countryCode: "cu",
		dialCode: "+53",
		currency: "cup",
	},
	{
		uuid: "9d057d2d-1ca3-4fd0-b9cb-fe9dc69798d4",
		name: "Cyprus",
		countryCode: "cy",
		dialCode: "+357",
		currency: "eur",
	},
	{
		uuid: "9d057d2d-1ca5-4a64-b85f-d3f492832a3e",
		name: "Czech Republic",
		countryCode: "cz",
		dialCode: "+420",
		currency: "czk",
	},
	{
		uuid: "9d057d2d-1cac-426a-8bfd-b8931afc6e63",
		name: "Democratic Republic of the Congo",
		countryCode: "cd",
		dialCode: "+243",
		currency: "cdf",
	},
	{
		uuid: "9d057d2d-1caf-4ebe-867d-e17a57c3ec0f",
		name: "Denmark",
		countryCode: "dk",
		dialCode: "+45",
		currency: "dkk",
	},
	{
		uuid: "9d057d2d-1cb0-477c-90fa-fe1d51f2d209",
		name: "Djibouti",
		countryCode: "dj",
		dialCode: "+253",
		currency: "djf",
	},
	{
		uuid: "9d057d2d-1cb2-4c93-a582-1e6503d3f222",
		name: "Dominica",
		countryCode: "dm",
		dialCode: "-766",
		currency: "xcd",
	},
	{
		uuid: "9d057d2d-1cb4-48e2-ab63-7fdbb5fc2b23",
		name: "Dominican Republic",
		countryCode: "do",
		dialCode: "+1",
		currency: "dop",
	},
	{
		uuid: "9d057d2d-1cb5-4d9d-91ff-3e024823c5d6",
		name: "East Timor",
		countryCode: "tl",
		dialCode: "+670",
		currency: "usd",
	},
	{
		uuid: "9d057d2d-1cb7-4a72-8029-5f02a2c39020",
		name: "Ecuador",
		countryCode: "ec",
		dialCode: "+593",
		currency: "usd",
	},
	{
		uuid: "9d057d2d-1cb8-4513-9221-6fd99ff59362",
		name: "Egypt",
		countryCode: "eg",
		dialCode: "+20",
		currency: "egp",
	},
	{
		uuid: "9d057d2d-1cba-45ea-929e-7cc66e2d72d4",
		name: "El Salvador",
		countryCode: "sv",
		dialCode: "+503",
		currency: "usd",
	},
	{
		uuid: "9d057d2d-1cbb-4a49-90a4-20fb1ef49e25",
		name: "Equatorial Guinea",
		countryCode: "gq",
		dialCode: "+240",
		currency: "xaf",
	},
	{
		uuid: "9d057d2d-1cbd-4021-8d23-a5af41c864ab",
		name: "Eritrea",
		countryCode: "er",
		dialCode: "+291",
		currency: "ern",
	},
	{
		uuid: "9d057d2d-1cbe-4291-9c8f-160a6612be63",
		name: "Estonia",
		countryCode: "ee",
		dialCode: "+372",
		currency: "eur",
	},
	{
		uuid: "9d057d2d-1cbf-4666-88d2-a61a335d0d05",
		name: "Ethiopia",
		countryCode: "et",
		dialCode: "+251",
		currency: "etb",
	},
	{
		uuid: "9d057d2d-1cc1-43dd-b218-7a8a79f41eea",
		name: "Falkland Islands",
		countryCode: "fk",
		dialCode: "+500",
		currency: "fkp",
	},
	{
		uuid: "9d057d2d-1cc2-41af-b73a-2f4c8298551c",
		name: "Faroe Islands",
		countryCode: "fo",
		dialCode: "+298",
		currency: "dkk",
	},
	{
		uuid: "9d057d2d-1cc4-4cae-955c-13e7217c4cf4",
		name: "Fiji Islands",
		countryCode: "fj",
		dialCode: "+679",
		currency: "fjd",
	},
	{
		uuid: "9d057d2d-1cc5-44ec-afa9-1eeaeeba3533",
		name: "Finland",
		countryCode: "fi",
		dialCode: "+358",
		currency: "eur",
	},
	{
		uuid: "9d057d2d-1cc7-4611-bbd3-dfa523858cf1",
		name: "France",
		countryCode: "fr",
		dialCode: "+33",
		currency: "eur",
	},
	{
		uuid: "9d057d2d-1cc8-4a4b-a4a3-66474ad733cb",
		name: "French Guiana",
		countryCode: "gf",
		dialCode: "+594",
		currency: "eur",
	},
	{
		uuid: "9d057d2d-1cca-436c-8702-ac22b36d651a",
		name: "French Polynesia",
		countryCode: "pf",
		dialCode: "+689",
		currency: "xpf",
	},
	{
		uuid: "9d057d2d-1ccb-469e-8ffb-1a1b2ce4a6d2",
		name: "French Southern Territories",
		countryCode: "tf",
		dialCode: "+262",
		currency: "eur",
	},
	{
		uuid: "9d057d2d-1ccd-40e9-80ee-3b71606c673f",
		name: "Gabon",
		countryCode: "ga",
		dialCode: "+241",
		currency: "xaf",
	},
	{
		uuid: "9d057d2d-1cce-48ff-8ef0-ead96f75162d",
		name: "Georgia",
		countryCode: "ge",
		dialCode: "+995",
		currency: "gel",
	},
	{
		uuid: "9d057d2d-1cd0-42f3-9e51-49fa61fff848",
		name: "Germany",
		countryCode: "de",
		dialCode: "+49",
		currency: "eur",
	},
	{
		uuid: "9d057d2d-1cd1-484f-9785-074cdfd856e0",
		name: "Ghana",
		countryCode: "gh",
		dialCode: "+233",
		currency: "ghs",
	},
	{
		uuid: "9d057d2d-1cd3-4d1d-b474-4ea092a62c98",
		name: "Gibraltar",
		countryCode: "gi",
		dialCode: "+350",
		currency: "gip",
	},
	{
		uuid: "9d057d2d-1cd4-4630-bce2-18304f5d79c4",
		name: "Greece",
		countryCode: "gr",
		dialCode: "+30",
		currency: "eur",
	},
	{
		uuid: "9d057d2d-1cd6-43cb-97b6-c1a14370be9a",
		name: "Greenland",
		countryCode: "gl",
		dialCode: "+299",
		currency: "dkk",
	},
	{
		uuid: "9d057d2d-1cd7-44e8-961d-21e973ea9921",
		name: "Grenada",
		countryCode: "gd",
		dialCode: "-472",
		currency: "xcd",
	},
	{
		uuid: "9d057d2d-1cd9-4094-a373-977c731def3c",
		name: "Guadeloupe",
		countryCode: "gp",
		dialCode: "+590",
		currency: "eur",
	},
	{
		uuid: "9d057d2d-1cda-4c25-8721-1fa46eac2434",
		name: "Guam",
		countryCode: "gu",
		dialCode: "-670",
		currency: "usd",
	},
	{
		uuid: "9d057d2d-1cdc-4acd-8dae-4d7f3266726a",
		name: "Guatemala",
		countryCode: "gt",
		dialCode: "+502",
		currency: "gtq",
	},
	{
		uuid: "9d057d2d-1cdd-4c33-84e5-2ca332c41d9e",
		name: "Guernsey & Alderney",
		countryCode: "gg",
		dialCode: "-1437",
		currency: "gbp",
	},
	{
		uuid: "9d057d2d-1cdf-4110-a17d-a857455f808c",
		name: "Gu-Bissau",
		countryCode: "gw",
		dialCode: "+245",
		currency: "xof",
	},
	{
		uuid: "9d057d2d-1ce0-49a7-9b1d-11ac1a84a76a",
		name: "Guinea",
		countryCode: "gn",
		dialCode: "+224",
		currency: "gnf",
	},
	{
		uuid: "9d057d2d-1ce2-490d-a3d7-19e933d847f7",
		name: "Guyana",
		countryCode: "gy",
		dialCode: "+592",
		currency: "gyd",
	},
	{
		uuid: "9d057d2d-1ce3-4a75-9e86-66211dd1d616",
		name: "Haiti",
		countryCode: "ht",
		dialCode: "+509",
		currency: "htg",
	},
	{
		uuid: "9d057d2d-1ce5-46fe-84af-d41f5094d496",
		name: "Heard Island & Mcdonald Islands",
		countryCode: "hm",
		dialCode: "+672",
		currency: "aud",
	},
	{
		uuid: "9d057d2d-1ce6-43e6-b000-0e0742413dd7",
		name: "Honduras",
		countryCode: "hn",
		dialCode: "+504",
		currency: "hnl",
	},
	{
		uuid: "9d057d2d-1ce7-4502-9721-3b7c89215718",
		name: "Hong Kong S.A.R.",
		countryCode: "hk",
		dialCode: "+852",
		currency: "hkd",
	},
	{
		uuid: "9d057d2d-1ce9-4503-8d62-082625f4ebba",
		name: "Hungary",
		countryCode: "hu",
		dialCode: "+36",
		currency: "huf",
	},
	{
		uuid: "9d057d2d-1ceb-4bb9-b2c0-65c8a97e8e7d",
		name: "Iceland",
		countryCode: "is",
		dialCode: "+354",
		currency: "isk",
	},
	{
		uuid: "9d057d5c-d8ed-4bec-ae92-f5d79051c57d",
		name: "India",
		countryCode: "in",
		dialCode: "+91",
		currency: "inr",
	},
	{
		uuid: "9d057d5c-d8f7-4184-b719-e43f6f08560f",
		name: "Indonesia",
		countryCode: "id",
		dialCode: "+62",
		currency: "idr",
	},
	{
		uuid: "9d057d5c-d8f9-4a10-84c8-a71e2b7b20bd",
		name: "Iran",
		countryCode: "ir",
		dialCode: "+98",
		currency: "irr",
	},
	{
		uuid: "9d057d5c-d8fb-4081-b8f6-2d919a9a5b3d",
		name: "Iraq",
		countryCode: "iq",
		dialCode: "+964",
		currency: "iqd",
	},
	{
		uuid: "9d057d5c-d8fd-41bb-a33b-f0cf28707924",
		name: "Ireland",
		countryCode: "ie",
		dialCode: "+353",
		currency: "eur",
	},
	{
		uuid: "9d057d5c-d8fe-4174-8782-a2b5d2ac4898",
		name: "Isle of Man",
		countryCode: "im",
		dialCode: "-1580",
		currency: "gbp",
	},
	{
		uuid: "9d057d5c-d900-4986-86bb-1b35b3b4aa06",
		name: "Israel",
		countryCode: "il",
		dialCode: "+972",
		currency: "ils",
	},
	{
		uuid: "9d057d5c-d902-4537-9b3b-620535c7e24e",
		name: "Italy",
		countryCode: "it",
		dialCode: "+39",
		currency: "eur",
	},
	{
		uuid: "9d057d5c-d903-4e3a-988e-c09e378a11f1",
		name: "Jamaica",
		countryCode: "jm",
		dialCode: "-875",
		currency: "jmd",
	},
	{
		uuid: "9d057d5c-d905-4a36-a441-b9d869e68697",
		name: "Japan",
		countryCode: "jp",
		dialCode: "+81",
		currency: "jpy",
	},
	{
		uuid: "9d057d5c-d906-4a99-af2b-4a3db15f9764",
		name: "Jersey",
		countryCode: "je",
		dialCode: "-1490",
		currency: "gbp",
	},
	{
		uuid: "9d057d5c-d908-4769-9292-05a7cd0b3395",
		name: "Jordan",
		countryCode: "jo",
		dialCode: "+962",
		currency: "jod",
	},
	{
		uuid: "9d057d5c-d90a-4f9e-8270-5141ee1f897d",
		name: "Kazakhstan",
		countryCode: "kz",
		dialCode: "+7",
		currency: "kzt",
	},
	{
		uuid: "9d057d5c-d90b-4a9a-af60-195b51d6b3ca",
		name: "Kenya",
		countryCode: "ke",
		dialCode: "+254",
		currency: "kes",
	},
	{
		uuid: "9d057d5c-d90d-49f8-bc51-bfa22c9144a1",
		name: "Kiribati",
		countryCode: "ki",
		dialCode: "+686",
		currency: "aud",
	},
	{
		uuid: "9d057d5c-d90e-4c79-90df-57f28732a0cd",
		name: "Kosovo",
		countryCode: "xk",
		dialCode: "+383",
		currency: "eur",
	},
	{
		uuid: "9d057d5c-d910-4fce-b92c-b4096943d34a",
		name: "Kuwait",
		countryCode: "kw",
		dialCode: "+965",
		currency: "kwd",
	},
	{
		uuid: "9d057d5c-d911-49dd-a7ac-4579502ca266",
		name: "Kyrgyzstan",
		countryCode: "kg",
		dialCode: "+996",
		currency: "kgs",
	},
	{
		uuid: "9d057d5c-d913-43c3-97a4-8fa5d66c21d4",
		name: "Laos",
		countryCode: "la",
		dialCode: "+856",
		currency: "lak",
	},
	{
		uuid: "9d057d5c-d914-4026-9cc8-40ff5d2a57da",
		name: "Latvia",
		countryCode: "lv",
		dialCode: "+371",
		currency: "eur",
	},
	{
		uuid: "9d057d5c-d916-4feb-a7b6-5670fa4a73d7",
		name: "Lebanon",
		countryCode: "lb",
		dialCode: "+961",
		currency: "lbp",
	},
	{
		uuid: "9d057d5c-d917-4803-ac3d-a5bad2b69ff0",
		name: "Lesotho",
		countryCode: "ls",
		dialCode: "+266",
		currency: "lsl",
	},
	{
		uuid: "9d057d5c-d919-4940-b16e-76260aeadc05",
		name: "Liberia",
		countryCode: "lr",
		dialCode: "+231",
		currency: "lrd",
	},
	{
		uuid: "9d057d5c-d91a-4bac-bcc9-a1cdf4956737",
		name: "Libya",
		countryCode: "ly",
		dialCode: "+218",
		currency: "lyd",
	},
	{
		uuid: "9d057d5c-d91c-4296-ad9e-2156c1c9ca6d",
		name: "Liechtenstein",
		countryCode: "li",
		dialCode: "+423",
		currency: "chf",
	},
	{
		uuid: "9d057d5c-d91d-40f2-86cd-563e7a907817",
		name: "Lithuania",
		countryCode: "lt",
		dialCode: "+370",
		currency: "eur",
	},
	{
		uuid: "9d057d5c-d91f-40ab-adb7-ab66c1d3c8d6",
		name: "Luxembourg",
		countryCode: "lu",
		dialCode: "+352",
		currency: "eur",
	},
	{
		uuid: "9d057d5c-d920-4b1f-bc09-a0067b023b80",
		name: "Macau S.A.R.",
		countryCode: "mo",
		dialCode: "+853",
		currency: "mop",
	},
	{
		uuid: "9d057d5c-d922-4839-a0e5-aba515a49ec6",
		name: "Madagascar",
		countryCode: "mg",
		dialCode: "+261",
		currency: "mga",
	},
	{
		uuid: "9d057d5c-d923-47c1-ab03-740b736b22a7",
		name: "Malawi",
		countryCode: "mw",
		dialCode: "+265",
		currency: "mwk",
	},
	{
		uuid: "9d057d5c-d925-42e6-995e-0dff52015ca9",
		name: "Malaysia",
		countryCode: "my",
		dialCode: "+60",
		currency: "myr",
	},
	{
		uuid: "9d057d5c-d926-48d4-ad00-9e60e2667648",
		name: "Maldives",
		countryCode: "mv",
		dialCode: "+960",
		currency: "mvr",
	},
	{
		uuid: "9d057d5c-d928-4043-9d2d-ad3e1db1f891",
		name: "Mali",
		countryCode: "ml",
		dialCode: "+223",
		currency: "xof",
	},
	{
		uuid: "9d057d5c-d929-485e-b27b-060e540d1f0e",
		name: "Malta",
		countryCode: "mt",
		dialCode: "+356",
		currency: "eur",
	},
	{
		uuid: "9d057d5c-d92b-4deb-84ca-f3f65f053da9",
		name: "Marshall Islands",
		countryCode: "mh",
		dialCode: "+692",
		currency: "usd",
	},
	{
		uuid: "9d057d5c-d92c-4883-85db-f67ea9d01f2f",
		name: "Martinique",
		countryCode: "mq",
		dialCode: "+596",
		currency: "eur",
	},
	{
		uuid: "9d057d5c-d92e-467a-872c-1b2a2d0538c4",
		name: "Mauritania",
		countryCode: "mr",
		dialCode: "+222",
		currency: "mro",
	},
	{
		uuid: "9d057d5c-d930-48b4-a0ca-e0f7728f72f0",
		name: "Mauritius",
		countryCode: "mu",
		dialCode: "+230",
		currency: "mur",
	},
	{
		uuid: "9d057d5c-d931-45f0-ba63-bab6404d4270",
		name: "Mayotte",
		countryCode: "yt",
		dialCode: "+262",
		currency: "eur",
	},
	{
		uuid: "9d057d5c-d933-4c3f-b863-ee2db92d0c31",
		name: "Mexico",
		countryCode: "mx",
		dialCode: "+52",
		currency: "mxn",
	},
	{
		uuid: "9d057d5c-d934-41be-8fec-2606520b064e",
		name: "Micronesia",
		countryCode: "fm",
		dialCode: "+691",
		currency: "usd",
	},
	{
		uuid: "9d057d5c-d936-46a4-949a-8896cc32c9d5",
		name: "Moldova",
		countryCode: "md",
		dialCode: "+373",
		currency: "mdl",
	},
	{
		uuid: "9d057d5c-d937-49bc-a608-30e51524941f",
		name: "Monaco",
		countryCode: "mc",
		dialCode: "+377",
		currency: "eur",
	},
	{
		uuid: "9d057d5c-d939-4526-9f65-896b35bf25a4",
		name: "Mongolia",
		countryCode: "mn",
		dialCode: "+976",
		currency: "mnt",
	},
	{
		uuid: "9d057d5c-d93a-49c0-84e2-e03841f9337d",
		name: "Montenegro",
		countryCode: "me",
		dialCode: "+382",
		currency: "eur",
	},
	{
		uuid: "9d057d5c-d93c-49fe-af10-301285ec31bc",
		name: "Montserrat",
		countryCode: "ms",
		dialCode: "-663",
		currency: "xcd",
	},
	{
		uuid: "9d057d5c-d93d-4f38-985d-9f33379059d6",
		name: "Morocco",
		countryCode: "ma",
		dialCode: "+212",
		currency: "mad",
	},
	{
		uuid: "9d057d5c-d93f-415e-9672-bf6bacbdb348",
		name: "Mozambique",
		countryCode: "mz",
		dialCode: "+258",
		currency: "mzn",
	},
	{
		uuid: "9d057d5c-d940-4a09-a708-813021d4370b",
		name: "Myanmar",
		countryCode: "mm",
		dialCode: "+95",
		currency: "mmk",
	},
	{
		uuid: "9d057d5c-d942-463e-b18c-ac5410ae27d8",
		name: "Namibia",
		countryCode: "na",
		dialCode: "+264",
		currency: "nad",
	},
	{
		uuid: "9d057d5c-d943-48c9-9b1f-ea91e0bed3f6",
		name: "Nauru",
		countryCode: "nr",
		dialCode: "+674",
		currency: "aud",
	},
	{
		uuid: "9d057d5c-d945-4279-ab4d-42022973cfe2",
		name: "Nepal",
		countryCode: "np",
		dialCode: "+977",
		currency: "npr",
	},
	{
		uuid: "9d057d5c-d946-414e-a970-fe31f8d32f60",
		name: "Netherlands",
		countryCode: "nl",
		dialCode: "+31",
		currency: "eur",
	},
	{
		uuid: "9d057d5c-d948-4c4f-a12a-9e51617818d6",
		name: "New Caledonia",
		countryCode: "nc",
		dialCode: "+687",
		currency: "xpf",
	},
	{
		uuid: "9d057d5c-d949-4b9e-a557-2efeeb448af2",
		name: "New Zealand",
		countryCode: "nz",
		dialCode: "+64",
		currency: "nzd",
	},
	{
		uuid: "9d057d5c-d94b-4b02-a9f5-db48e3cad4e8",
		name: "Nicaragua",
		countryCode: "ni",
		dialCode: "+505",
		currency: "nio",
	},
	{
		uuid: "9d057d5c-d94c-440a-b172-fdd42f4aab56",
		name: "Niger",
		countryCode: "ne",
		dialCode: "+227",
		currency: "xof",
	},
	{
		uuid: "9d057d5c-d94e-4579-8afc-b110f0da3053",
		name: "Nigeria",
		countryCode: "ng",
		dialCode: "+234",
		currency: "ngn",
	},
	{
		uuid: "9d057d5c-d94f-4c5b-8013-789c869ff613",
		name: "Niue",
		countryCode: "nu",
		dialCode: "+683",
		currency: "nzd",
	},
	{
		uuid: "9d057d5c-d951-471d-86e6-0bbf9c1ea4d8",
		name: "Norfolk Island",
		countryCode: "nf",
		dialCode: "+672",
		currency: "aud",
	},
	{
		uuid: "9d057d5c-d952-4b25-ab27-f00289fb1f3c",
		name: "North Korea",
		countryCode: "kp",
		dialCode: "+850",
		currency: "kpw",
	},
	{
		uuid: "9d057d5c-d954-43ed-b6fc-b6a96df97f4d",
		name: "North Macedonia",
		countryCode: "mk",
		dialCode: "+389",
		currency: "mkd",
	},
	{
		uuid: "9d057d5c-d956-4440-8bb3-8a5848bd1ee2",
		name: "Northern Mariana Islands",
		countryCode: "mp",
		dialCode: "-669",
		currency: "usd",
	},
	{
		uuid: "9d057d5c-d95b-4f4a-856f-4172d5ad84bc",
		name: "Norway",
		countryCode: "no",
		dialCode: "+47",
		currency: "nok",
	},
	{
		uuid: "9d057d5c-d95d-4365-9971-e4806ba9e0b8",
		name: "Oman",
		countryCode: "om",
		dialCode: "+968",
		currency: "omr",
	},
	{
		uuid: "9d057d5c-d95e-4c30-bebc-fc5c51908821",
		name: "Pakistan",
		countryCode: "pk",
		dialCode: "+92",
		currency: "pkr",
	},
	{
		uuid: "9d057d5c-d960-4fc3-9727-bff07c828b76",
		name: "Palau",
		countryCode: "pw",
		dialCode: "+680",
		currency: "usd",
	},
	{
		uuid: "9d057d5c-d961-4017-a3cc-a388565fff43",
		name: "Palestinian Territory",
		countryCode: "ps",
		dialCode: "+970",
		currency: "ils",
	},
	{
		uuid: "9d057d5c-d963-4f29-bfb8-839a0e1cab13",
		name: "Panama",
		countryCode: "pa",
		dialCode: "+507",
		currency: "pab",
	},
	{
		uuid: "9d057d5c-d965-4f06-95cd-6614524ea88a",
		name: "Papua New Guinea",
		countryCode: "pg",
		dialCode: "+675",
		currency: "pgk",
	},
	{
		uuid: "9d057d5c-d966-4ff2-bf47-fc74eff12228",
		name: "Paraguay",
		countryCode: "py",
		dialCode: "+595",
		currency: "pyg",
	},
	{
		uuid: "9d057d5c-d968-4f4b-8dd5-f3dc8090a621",
		name: "Peru",
		countryCode: "pe",
		dialCode: "+51",
		currency: "pen",
	},
	{
		uuid: "9d057d5c-d969-4901-99c1-5eec5cdda446",
		name: "Philippines",
		countryCode: "ph",
		dialCode: "+63",
		currency: "php",
	},
	{
		uuid: "9d057d5c-d96b-469f-9157-4d4a48470578",
		name: "Pitcairn Island",
		countryCode: "pn",
		dialCode: "+870",
		currency: "nzd",
	},
	{
		uuid: "9d057d5c-d96c-494b-9571-c4820604287f",
		name: "Poland",
		countryCode: "pl",
		dialCode: "+48",
		currency: "pln",
	},
	{
		uuid: "9d057d5c-d96e-429d-8144-fbb32d4930c3",
		name: "Portugal",
		countryCode: "pt",
		dialCode: "+351",
		currency: "eur",
	},
	{
		uuid: "9d057d5c-d96f-4cf9-af3b-b9ef7c21d698",
		name: "Puerto Rico",
		countryCode: "pr",
		dialCode: "+1",
		currency: "usd",
	},
	{
		uuid: "9d057d5c-d971-4689-a64a-4f43e105f62b",
		name: "Qatar",
		countryCode: "qa",
		dialCode: "+974",
		currency: "qar",
	},
	{
		uuid: "9d057d5c-d973-4da3-8842-beeca9c0982a",
		name: "Reunion",
		countryCode: "re",
		dialCode: "+262",
		currency: "eur",
	},
	{
		uuid: "9d057d5c-d974-4db9-b723-51c79ae30fdd",
		name: "Romania",
		countryCode: "ro",
		dialCode: "+40",
		currency: "ron",
	},
	{
		uuid: "9d057d5c-d976-4218-8235-dd4274233654",
		name: "Russia",
		countryCode: "ru",
		dialCode: "+7",
		currency: "rub",
	},
	{
		uuid: "9d057d5c-d977-40fc-bced-34fe06890e62",
		name: "Rwanda",
		countryCode: "rw",
		dialCode: "+250",
		currency: "rwf",
	},
	{
		uuid: "9d057d5c-d979-43d2-9a46-71971427c3ca",
		name: "Saint Barthelemy",
		countryCode: "bl",
		dialCode: "+590",
		currency: "eur",
	},
	{
		uuid: "9d057d5c-d97a-4f7a-8789-813dc66060d8",
		name: "Saint Helena",
		countryCode: "sh",
		dialCode: "+290",
		currency: "shp",
	},
	{
		uuid: "9d057d5c-d97c-4f02-8c6c-e6848643ca57",
		name: "Saint Kitts & Nevis",
		countryCode: "kn",
		dialCode: "-868",
		currency: "xcd",
	},
	{
		uuid: "9d057d5c-d97d-474e-a459-535bb6101f2d",
		name: "Saint Lucia",
		countryCode: "lc",
		dialCode: "-757",
		currency: "xcd",
	},
	{
		uuid: "9d057d5c-d97f-4164-a92d-858bcb29b59d",
		name: "Saint Martin",
		countryCode: "mf",
		dialCode: "+590",
		currency: "eur",
	},
	{
		uuid: "9d057d5c-d981-4e25-8988-ea7ed17a0952",
		name: "Saint Pierre & Miquelon",
		countryCode: "pm",
		dialCode: "+508",
		currency: "eur",
	},
	{
		uuid: "9d057d5c-d982-4328-aab0-7b63ca8a23ac",
		name: "Saint Vincent & the Grenadines",
		countryCode: "vc",
		dialCode: "-783",
		currency: "xcd",
	},
	{
		uuid: "9d057d5c-d984-45dd-8d28-79cfa05b7dda",
		name: "Samoa",
		countryCode: "ws",
		dialCode: "+685",
		currency: "wst",
	},
	{
		uuid: "9d057d5c-d989-4c24-840f-af64b74f9eb8",
		name: "San Marino",
		countryCode: "sm",
		dialCode: "+378",
		currency: "eur",
	},
	{
		uuid: "9d057d5c-d98a-4b2d-9fe4-866980f5d1f9",
		name: "Sao Tome & Principe",
		countryCode: "st",
		dialCode: "+239",
		currency: "std",
	},
	{
		uuid: "9d057d5c-d98c-4add-8b6e-12d53945e99f",
		name: "Saudi Arabia",
		countryCode: "sa",
		dialCode: "+966",
		currency: "sar",
	},
	{
		uuid: "9d057d5c-d98d-4de4-82d7-bd94afe7ec7c",
		name: "Senegal",
		countryCode: "sn",
		dialCode: "+221",
		currency: "xof",
	},
	{
		uuid: "9d057d5c-d98f-4178-923a-9b4dae5f25f7",
		name: "Serbia",
		countryCode: "rs",
		dialCode: "+381",
		currency: "rsd",
	},
	{
		uuid: "9d057d5c-d990-4bcb-a6f9-5a773b6c0081",
		name: "Seychelles",
		countryCode: "sc",
		dialCode: "+248",
		currency: "scr",
	},
	{
		uuid: "9d057d5c-d992-4ca4-8e18-f004b15bfba7",
		name: "Sierra Leone",
		countryCode: "sl",
		dialCode: "+232",
		currency: "sll",
	},
	{
		uuid: "9d057d5c-d993-4f98-8701-30f2f02e3c11",
		name: "Singapore",
		countryCode: "sg",
		dialCode: "+65",
		currency: "sgd",
	},
	{
		uuid: "9d057d5c-d995-4db2-89f6-62dc91e55a1b",
		name: "Sint Maarten",
		countryCode: "sx",
		dialCode: "+1721",
		currency: "ang",
	},
	{
		uuid: "9d057d5c-d997-46fe-a27c-22b529f9ccdf",
		name: "Slovakia",
		countryCode: "sk",
		dialCode: "+421",
		currency: "eur",
	},
	{
		uuid: "9d057db2-127c-4485-822e-da07576ddc1d",
		name: "Slovenia",
		countryCode: "si",
		dialCode: "+386",
		currency: "eur",
	},
	{
		uuid: "9d057db2-1288-467f-ab88-c22ba11a2791",
		name: "Solomon Islands",
		countryCode: "sb",
		dialCode: "+677",
		currency: "sbd",
	},
	{
		uuid: "9d057db2-128b-45dd-857e-e2acc21d5c48",
		name: "Somalia",
		countryCode: "so",
		dialCode: "+252",
		currency: "sos",
	},
	{
		uuid: "9d057db2-128d-4827-b710-1eb486a49427",
		name: "South Africa",
		countryCode: "za",
		dialCode: "+27",
		currency: "zar",
	},
	{
		uuid: "9d057db2-128f-4018-a23a-3107105db5be",
		name: "South Georgia",
		countryCode: "gs",
		dialCode: "+500",
		currency: "gbp",
	},
	{
		uuid: "9d057db2-1291-4343-843a-eed75e786541",
		name: "South Korea",
		countryCode: "kr",
		dialCode: "+82",
		currency: "krw",
	},
	{
		uuid: "9d057db2-1293-48df-a0a2-4a547a4d68af",
		name: "South Sudan",
		countryCode: "ss",
		dialCode: "+211",
		currency: "ssp",
	},
	{
		uuid: "9d057db2-1295-4b27-bf73-b3e3f00324a4",
		name: "Spain",
		countryCode: "es",
		dialCode: "+34",
		currency: "eur",
	},
	{
		uuid: "9d057db2-1296-4e0a-8325-57a6376b3731",
		name: "Sri Lanka",
		countryCode: "lk",
		dialCode: "+94",
		currency: "lkr",
	},
	{
		uuid: "9d057db2-1298-44f3-a980-5de3ccfe4bb1",
		name: "Sudan",
		countryCode: "sd",
		dialCode: "+249",
		currency: "sdg",
	},
	{
		uuid: "9d057db2-129a-4ad4-a808-53971046012f",
		name: "Suriname",
		countryCode: "sr",
		dialCode: "+597",
		currency: "srd",
	},
	{
		uuid: "9d057db2-129b-493e-aa2d-cf6d1058a0c1",
		name: "Svalbard & Jan Mayen Islands",
		countryCode: "sj",
		dialCode: "+47",
		currency: "nok",
	},
	{
		uuid: "9d057db2-129d-4b53-84e6-66e5e24a64b0",
		name: "Swaziland",
		countryCode: "sz",
		dialCode: "+268",
		currency: "szl",
	},
	{
		uuid: "9d057db2-129f-40c6-b762-df2a46bbf4d2",
		name: "Sweden",
		countryCode: "se",
		dialCode: "+46",
		currency: "sek",
	},
	{
		uuid: "9d057db2-12a0-4f95-9b75-66af495577cc",
		name: "Switzerland",
		countryCode: "ch",
		dialCode: "+41",
		currency: "chf",
	},
	{
		uuid: "9d057db2-12a2-44ff-b903-603d457e6c32",
		name: "Syria",
		countryCode: "sy",
		dialCode: "+963",
		currency: "syp",
	},
	{
		uuid: "9d057db2-12a4-454d-9756-295da491bf42",
		name: "Taiwan",
		countryCode: "tw",
		dialCode: "+886",
		currency: "twd",
	},
	{
		uuid: "9d057db2-12a5-41e7-a7e0-0d7b3966d657",
		name: "Tajikistan",
		countryCode: "tj",
		dialCode: "+992",
		currency: "tjs",
	},
	{
		uuid: "9d057db2-12a7-4885-8cd5-b6895325d5bf",
		name: "Tanzania",
		countryCode: "tz",
		dialCode: "+255",
		currency: "tzs",
	},
	{
		uuid: "9d057db2-12a9-42dc-9e48-f42aff18c7d9",
		name: "Thailand",
		countryCode: "th",
		dialCode: "+66",
		currency: "thb",
	},
	{
		uuid: "9d057db2-12aa-40be-afd1-749c71220118",
		name: "The Bahamas",
		countryCode: "bs",
		dialCode: "-241",
		currency: "bsd",
	},
	{
		uuid: "9d057db2-12ac-4abf-94d7-636023fba473",
		name: "The Gambia",
		countryCode: "gm",
		dialCode: "+220",
		currency: "gmd",
	},
	{
		uuid: "9d057db2-12ae-49eb-9a33-668ec071b355",
		name: "Togo",
		countryCode: "tg",
		dialCode: "+228",
		currency: "xof",
	},
	{
		uuid: "9d057db2-12af-47fc-9c81-2d1f8bb95729",
		name: "Tokelau",
		countryCode: "tk",
		dialCode: "+690",
		currency: "nzd",
	},
	{
		uuid: "9d057db2-12b1-4ae1-9201-1abca7a655a9",
		name: "Tonga",
		countryCode: "to",
		dialCode: "+676",
		currency: "top",
	},
	{
		uuid: "9d057db2-12b3-49da-8898-4574f94f642e",
		name: "Trinidad & Tobago",
		countryCode: "tt",
		dialCode: "-867",
		currency: "ttd",
	},
	{
		uuid: "9d057db2-12b7-46da-af97-724b8e75c953",
		name: "Tunisia",
		countryCode: "tn",
		dialCode: "+216",
		currency: "tnd",
	},
	{
		uuid: "9d057db2-12b9-4bf3-a39a-239f5b4b9396",
		name: "Turkey",
		countryCode: "tr",
		dialCode: "+90",
		currency: "try",
	},
	{
		uuid: "9d057db2-12bb-4d0a-84f7-0945e908038c",
		name: "Turkmenistan",
		countryCode: "tm",
		dialCode: "+993",
		currency: "tmt",
	},
	{
		uuid: "9d057db2-12bd-4577-82b7-2c81609a4ae9",
		name: "Turks & Caicos Islands",
		countryCode: "tc",
		dialCode: "-648",
		currency: "usd",
	},
	{
		uuid: "9d057db2-12be-4fed-a9b9-63b2d5903b22",
		name: "Tuvalu",
		countryCode: "tv",
		dialCode: "+688",
		currency: "aud",
	},
	{
		uuid: "9d057db2-12c0-475c-859b-4e9ebfa9781a",
		name: "Uganda",
		countryCode: "ug",
		dialCode: "+256",
		currency: "ugx",
	},
	{
		uuid: "9d057db2-12c1-4ef6-b0c4-d505cf7c2ca0",
		name: "Ukraine",
		countryCode: "ua",
		dialCode: "+380",
		currency: "uah",
	},
	{
		uuid: "9d057db2-12c3-42a4-a3be-1cc7ce479c7a",
		name: "United Arab Emirates",
		countryCode: "ae",
		dialCode: "+971",
		currency: "aed",
	},
	{
		uuid: "9d057db2-12c5-4628-9fda-63190677d60a",
		name: "United Kingdom",
		countryCode: "gb",
		dialCode: "+44",
		currency: "gbp",
	},
	{
		uuid: "9d057db2-12c6-410b-bfca-e4b1630a685a",
		name: "United States",
		countryCode: "us",
		dialCode: "+1",
		currency: "usd",
	},
	{
		uuid: "9d057db2-12c8-40b7-8e2b-769f84d8331a",
		name: "United States Minor Outlying Islands",
		countryCode: "um",
		dialCode: "+1",
		currency: "usd",
	},
	{
		uuid: "9d057db2-12ca-45c8-9c84-1caa6582ffa2",
		name: "United States Virgin Islands",
		countryCode: "vi",
		dialCode: "-339",
		currency: "usd",
	},
	{
		uuid: "9d057db2-12cc-4898-a9d0-e643f91fd0e4",
		name: "Uruguay",
		countryCode: "uy",
		dialCode: "+598",
		currency: "uyu",
	},
	{
		uuid: "9d057db2-12cd-45d8-9a84-9a08c6a31c63",
		name: "Uzbekistan",
		countryCode: "uz",
		dialCode: "+998",
		currency: "uzs",
	},
	{
		uuid: "9d057db2-12cf-4b64-b5de-6b61853ac89a",
		name: "Vanuatu",
		countryCode: "vu",
		dialCode: "+678",
		currency: "vuv",
	},
	{
		uuid: "9d057db2-12d0-4571-889e-bc5a1f5e56a8",
		name: "Vatican City",
		countryCode: "va",
		dialCode: "+379",
		currency: "eur",
	},
	{
		uuid: "9d057db2-12d2-46ca-baa6-56554bad8908",
		name: "Venezuela",
		countryCode: "ve",
		dialCode: "+58",
		currency: "vef",
	},
	{
		uuid: "9d057db2-12d4-42f0-b641-4d6c5a818cca",
		name: "Vietnam",
		countryCode: "vn",
		dialCode: "+84",
		currency: "vnd",
	},
	{
		uuid: "9d057db2-12d5-4907-860b-f27f29e9298e",
		name: "Wallis & Futuna Islands",
		countryCode: "wf",
		dialCode: "+681",
		currency: "xpf",
	},
	{
		uuid: "9d057db2-12d7-41e0-87d7-e3819e763271",
		name: "Western Sahara",
		countryCode: "eh",
		dialCode: "+212",
		currency: "mad",
	},
	{
		uuid: "9d057db2-12d9-436b-b080-a63e3c64eba8",
		name: "Yemen",
		countryCode: "ye",
		dialCode: "+967",
		currency: "yer",
	},
	{
		uuid: "9d057db2-12da-4c07-bc48-fcb505012f3e",
		name: "Zambia",
		countryCode: "zm",
		dialCode: "+260",
		currency: "zmw",
	},
	{
		uuid: "9d057db2-12dc-4a9a-bf09-cbe69179c613",
		name: "Zimbabwe",
		countryCode: "zw",
		dialCode: "+263",
		currency: "zwl",
	},
];
